import script from "./BalModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalModal.vue?vue&type=script&lang=ts&setup=true"

import "./BalModal.vue?vue&type=style&index=0&id=4b5b69a1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5b69a1"]])

export default __exports__